import { defineMessages } from '@jutro/locale';

export default defineMessages({
    effectiveDateColumn: {
        id: 'ml.gateway.views.ActivityReports.MLIncompletePendedReport.EFFECTIVE DATE',
        defaultMessage: 'EFFECTIVE DATE'
    },
    customerNameColumn: {
        id: 'ml.gateway.views.ActivityReports.MLIncompletePendedReport.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    productColumn: {
        id: 'ml.gateway.views.ActivityReports.MLIncompletePendedReport.PRODUCT',
        defaultMessage: 'PRODUCT'
    },
    policyColumn: {
        id: 'ml.gateway.views.ActivityReports.MLIncompletePendedReport.POLICY #',
        defaultMessage: 'POLICY #'
    },
    descriptionColumn: {
        id: 'ml.gateway.views.ActivityReports.MLIncompletePendedReport.DESCRIPTION',
        defaultMessage: 'DESCRIPTION'
    },
    noIncompletePendedFound: {
        id: 'ml.gateway.views.ActivityReports.MLIncompletePendedReport.No incomplete/pending policies found',
        defaultMessage: 'No incomplete/pending policies found'
    },
    loading: {
        id: 'ml.gateway.views.ActivityReports.MLIncompletePendedReport.Loading...',
        defaultMessage: 'Loading...'
    },
    viewAllPolicyChanges: {
        id: 'ml.gateway.views.ActivityReports.MLIncompletePendedReport.VIEW ALL POLICY CHANGES',
        defaultMessage: 'VIEW ALL CANCELLATIONSVIEW ALL POLICY CHANGES'
    }
});
